<template>
  <div class="md:container px-4 relative z-10">
    <div class="card text-center -mt-38 py-10 rounded-16">
      <div class="w-full lg:w-1/2 mx-auto">
        <h3 class="font-bree-serif text-primary lg:text-4xl md:text-3xl mb-8">
          {{ $t('testimonial') }}
        </h3>
        <h4 class="text-xl mb-2">
          - YesDok eHealth Care -
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Testimonial'
}
</script>

<style scoped>

</style>
